import React, { useContext } from 'react';
import { CsvImporterController, CsvImporterControllerProps } from './CsvImporter.controller';
import { useGetCategoriesQuery } from '../../../models/graphql';
import { AppContext } from '../../../providers/AppProvider';
import { useRequiredQueries } from '../../../hooks/useRequiredQueries';

export const CsvImporterApollo = (): JSX.Element => {
  const { selectedWorkspaceId } = useContext(AppContext);

  const getCategoriesQueryResult = useGetCategoriesQuery({ variables: { workspaceId: selectedWorkspaceId } });

  useRequiredQueries([getCategoriesQueryResult]);

  const controllerProps: CsvImporterControllerProps = {
    categories: getCategoriesQueryResult.data?.workspace.categories || [],
    loading: getCategoriesQueryResult.loading
  };

  return <CsvImporterController {...controllerProps} />;
};
